/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Title_PlaceholderInputs */

const en_admin_permissions_title_placeholder = /** @type {(inputs: Admin_Permissions_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Create Posts`)
};

const zh_admin_permissions_title_placeholder = /** @type {(inputs: Admin_Permissions_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 创建文章`)
};

/**
* | output |
* | --- |
* | "e.g. Create Posts" |
*
* @param {Admin_Permissions_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_title_placeholder = /** @type {((inputs?: Admin_Permissions_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_title_placeholder(inputs)
	return zh_admin_permissions_title_placeholder(inputs)
});
export { admin_permissions_title_placeholder as "admin.permissions.title_placeholder" }